import type {FunctionImplementation} from "@otto-ec/global-resources/nexus";
import {type ThirdpartyTracking, thirdpartyTracking} from './index';
import { AppType, appType} from "../helper";
import type {AdjustPayload} from "./adjustPayload";

export const trackAdjust = function (adjustPayload: AdjustPayload) {
    if (appType() == AppType.ANDROID) {
        const androidAdjustPayload = JSON.stringify(adjustPayload);
        window.o_apps_android?.trackAdjust?.(androidAdjustPayload);
    } else if (appType() == AppType.IOS) {
        window.webkit?.messageHandlers?.trackAdjust?.postMessage(adjustPayload);
    }
} satisfies FunctionImplementation<ThirdpartyTracking["trackAdjust"]>

thirdpartyTracking.assignNamespace({trackAdjust})